import { useState } from "react";
import { ScanBarcode } from "lucide-react";
import { Input } from "@/components/ui/input";
import { BarkodKamera } from "@/components/bayi/BarkodKamera";

export const bip = (iyi) => {
  try {
    const c = new (window.AudioContext || window.webkitAudioContext)();
    const o = c.createOscillator(); o.frequency.value = iyi ? 1200 : 220; o.connect(c.destination); o.start(); o.stop(c.currentTime + (iyi ? 0.08 : 0.35));
  } catch { /* ses desteklenmiyor */ }
};

export const barkodEslestir = (liste, kod) => {
  const k = (kod || "").trim().toLowerCase();
  for (const x of liste) {
    const b = (x.barkodlar || []).find((y) => String(y.barkod).toLowerCase() === k);
    if (b) return { x, carpan: Number(b.carpan) || 1, birim: b.birim };
  }
  return null;
};

export const BarkodOkut = ({ onKod, testid = "barkod", ipucu = "Barkod okutun veya yazıp Enter'a basın" }) => {
  const [v, setV] = useState("");
  const gonder = () => { const k = v.trim(); if (k) onKod(k); setV(""); };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testid}-alan`}>
      <div className="relative flex-1 min-w-[220px]">
        <ScanBarcode className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--g1)]" />
        <Input data-testid={`${testid}-input`} value={v} placeholder={ipucu} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); gonder(); } }} className="pl-9 bg-white/5 font-mono" />
      </div>
      <BarkodKamera testid={`${testid}-kamera`} etiket="Resim çek / okut" onOku={onKod} />
    </div>
  );
};
